import '@/assets/reset.css'
import 'vue-toast-notification/dist/theme-sugar.css'
import 'vue2-datepicker/index.css';

import Vue from 'vue'
import App from './components/App.vue'

import useTooltip from 'v-tooltip'
import useToast from 'vue-toast-notification'
import useDatePicker from 'vue2-datepicker'
import useClickOutside from 'v-click-outside'
import useClipboard from 'vue-clipboard2'

import _ from 'underscore'
import moment from 'moment-timezone'
import pubsub from './pubsub'
import constants from './constants'
import router from './router'
import store from './store'
import api from './api'
import util from './util'

import mixinInjection from './mixin/injection'
import mixinShortcuts from './mixin/shortcuts'
import mixinWindow from './mixin/window'

import routerGuard from './router/guard' 

var requireComponentGlobal = require.context('./components/common', true, /[A-Z]\w+\.(vue|js)$/)

requireComponentGlobal.keys().forEach(function(filename) {

	var componentConfig = requireComponentGlobal(filename)
	var componentName = 'app' + filename.replace(/\//g, '-').replace('.vue', '').replace('.', '').toLowerCase()

	Vue.component(
		componentName,
		componentConfig.default
	)

})

router.beforeEach(routerGuard)

Vue.use(useTooltip)
Vue.use(useToast)
Vue.use(useDatePicker)
Vue.use(useClickOutside)
Vue.use(useClipboard)

Vue.mixin(mixinWindow)
Vue.mixin(mixinInjection)
Vue.mixin(mixinShortcuts)

new Vue({
	_,
	moment,
	router,
	constants,
	util,
  pubsub,
	store,
	api,
	render: h => h(App),
	created: function() {

		pubsub.$emit('window.initiated')

	}
}).$mount('#app')